import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';
import { ValidationsService } from '../../services/validations.service';

@Directive({
  selector: '[appStringMatch]',
  providers: [{ provide: NG_VALIDATORS, useExisting: StringMatchDirective, multi: true }],
})
export class StringMatchDirective implements Validator {
  @Input('appStringMatch') fields: string[] = [];

  validate(formGroup: FormGroup): ValidationErrors | null {
    if (this.fields.length < 1) return null;

    return ValidationsService.stringComparisonValidator(this.fields[0], this.fields[1])(formGroup);
  }
}
